import { useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';

const NewsPage = () => {
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [subscriptionStatus, setSubscriptionStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const categories = [
    { id: 'all', name: 'All News', icon: 'ri-newspaper-line' },
    { id: 'company', name: 'Company News', icon: 'ri-building-line' },
    { id: 'industry', name: 'Industry Insights', icon: 'ri-lightbulb-line' },
    { id: 'technology', name: 'Technology', icon: 'ri-cpu-line' },
    { id: 'sustainability', name: 'Sustainability', icon: 'ri-leaf-line' },
  ];

  const newsArticles = [
    {
      id: 1,
      category: 'company',
      title: 'Alpine Precision Molding Expands Production Capacity with New 1000-Ton Press',
      excerpt: 'We are excited to announce the installation of our latest state-of-the-art 1000-ton injection molding press, increasing our large-part manufacturing capabilities by 40%.',
      image: 'https://public.readdy.ai/ai/img_res/611dc932e4e55ff7421d2e27239ea77b.jpg',
      date: '2025-01-15',
      readTime: '4 min read',
      author: 'Ray Hernandez',
      tags: ['Expansion', 'Equipment', 'Capacity'],
    },
    {
      id: 2,
      category: 'industry',
      title: 'The Future of Automotive Lightweighting: Advanced Polymer Solutions',
      excerpt: 'Explore how engineering-grade polymers and fiber-reinforced composites are revolutionizing automotive manufacturing, reducing vehicle weight by up to 30% while maintaining structural integrity.',
      image: 'https://readdy.ai/api/search-image?query=Lightweight%20automotive%20polymer%20components%20fiber%20reinforced%20plastic%20parts%20modern%20car%20manufacturing%20advanced%20materials%20professional%20product%20photography%20white%20background&width=800&height=500&seq=news2&orientation=landscape',
      date: '2025-01-10',
      readTime: '6 min read',
      author: 'Luis Gonzalez',
      tags: ['Automotive', 'Materials', 'Innovation'],
    },
    {
      id: 3,
      category: 'sustainability',
      title: 'Achieving Carbon Neutrality: Our 2025 Sustainability Roadmap',
      excerpt: 'Alpine Precision Molding commits to carbon-neutral operations by 2030. Learn about our comprehensive sustainability initiatives including renewable energy adoption and recycled material integration.',
      image: 'https://readdy.ai/api/search-image?query=Green%20sustainable%20manufacturing%20facility%20with%20solar%20panels%20renewable%20energy%20eco-friendly%20industrial%20plant%20modern%20architecture%20environmental%20responsibility&width=800&height=500&seq=news3&orientation=landscape',
      date: '2025-01-05',
      readTime: '5 min read',
      author: 'Ruben Ponce',
      tags: ['Sustainability', 'Environment', 'Corporate Responsibility'],
    },
    {
      id: 4,
      category: 'technology',
      title: 'AI-Powered Quality Control: Reducing Defects to Near-Zero Levels',
      excerpt: 'Discover how our implementation of machine learning algorithms and computer vision systems has improved our quality control processes, achieving 99.98% defect-free production rates.',
      image: 'https://readdy.ai/api/search-image?query=Artificial%20intelligence%20quality%20control%20system%20computer%20vision%20inspection%20automated%20manufacturing%20technology%20robotic%20inspection%20professional%20industrial%20photography&width=800&height=500&seq=news4&orientation=landscape',
      date: '2024-12-28',
      readTime: '7 min read',
      author: 'Dave Smith',
      tags: ['AI', 'Quality Control', 'Automation'],
    },
    {
      id: 5,
      category: 'company',
      title: 'Alpine Precision Molding Receives ISO 13485:2016 Certification',
      excerpt: 'We are proud to announce our successful ISO 13485:2016 certification for medical device manufacturing, expanding our capabilities in the healthcare sector.',
      image: 'https://readdy.ai/api/search-image?query=ISO%20certification%20medical%20device%20manufacturing%20clean%20room%20facility%20quality%20management%20system%20professional%20healthcare%20industry%20environment&width=800&height=500&seq=news5&orientation=landscape',
      date: '2024-12-20',
      readTime: '3 min read',
      author: 'Ray Hernandez',
      tags: ['Certification', 'Medical', 'Quality'],
    },
    {
      id: 6,
      category: 'industry',
      title: 'Medical Device Manufacturing Trends: Miniaturization and Biocompatibility',
      excerpt: 'An in-depth look at emerging trends in medical device manufacturing, including micro-molding techniques and advanced biocompatible materials for implantable devices.',
      image: 'https://readdy.ai/api/search-image?query=Miniature%20medical%20device%20components%20precision%20micro%20molding%20biocompatible%20plastic%20parts%20healthcare%20technology%20professional%20product%20photography%20white%20background&width=800&height=500&seq=news6&orientation=landscape',
      date: '2024-12-15',
      readTime: '8 min read',
      author: 'Luis Gonzalez',
      tags: ['Medical', 'Innovation', 'Materials'],
    },
    {
      id: 7,
      category: 'technology',
      title: 'Multi-Material 3D Printing: Expanding Design Possibilities',
      excerpt: 'Learn how our latest multi-material 3D printing capabilities enable complex geometries and functional prototypes with varying material properties in a single build.',
      image: 'https://readdy.ai/api/search-image?query=Multi-material%203D%20printing%20advanced%20additive%20manufacturing%20colorful%20prototype%20parts%20modern%20technology%20professional%20industrial%20photography&width=800&height=500&seq=news7&orientation=landscape',
      date: '2024-12-08',
      readTime: '5 min read',
      author: 'Dave Smith',
      tags: ['3D Printing', 'Prototyping', 'Technology'],
    },
    {
      id: 8,
      category: 'sustainability',
      title: 'Circular Economy in Plastics: Our Recycling and Regrind Programs',
      excerpt: 'Discover how Alpine Precision Molding is leading the way in sustainable manufacturing through comprehensive recycling programs and post-consumer recycled material integration.',
      image: 'https://readdy.ai/api/search-image?query=Plastic%20recycling%20facility%20circular%20economy%20sustainable%20materials%20processing%20eco-friendly%20manufacturing%20green%20industrial%20operations%20professional%20photography&width=800&height=500&seq=news8&orientation=landscape',
      date: '2024-12-01',
      readTime: '6 min read',
      author: 'Ruben Ponce',
      tags: ['Recycling', 'Sustainability', 'Circular Economy'],
    },
    {
      id: 9,
      category: 'company',
      title: 'Partnership Announcement: Collaborating with European Aerospace Leaders',
      excerpt: 'Alpine Precision Molding announces strategic partnership with leading European aerospace manufacturers to develop next-generation lightweight components for commercial aircraft.',
      image: 'https://readdy.ai/api/search-image?query=Aerospace%20manufacturing%20partnership%20business%20collaboration%20modern%20aircraft%20components%20precision%20engineering%20professional%20corporate%20photography&width=800&height=500&seq=news9&orientation=landscape',
      date: '2024-11-25',
      readTime: '4 min read',
      author: 'Ray Hernandez',
      tags: ['Partnership', 'Aerospace', 'Growth'],
    },
  ];

  const featuredArticle = newsArticles[0];
  const regularArticles = newsArticles.slice(1);

  const filteredArticles = selectedCategory === 'all' 
    ? regularArticles 
    : regularArticles.filter(article => article.category === selectedCategory);

  const handleNewsletterSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    try {
      const response = await fetch('https://readdy.ai/api/form/d5un0i9r44f5krorkr3g', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formData as any).toString(),
      });

      if (response.ok) {
        setSubscriptionStatus('success');
        form.reset();
        setTimeout(() => setSubscriptionStatus('idle'), 5000);
      } else {
        setSubscriptionStatus('error');
        setTimeout(() => setSubscriptionStatus('idle'), 5000);
      }
    } catch (error) {
      setSubscriptionStatus('error');
      setTimeout(() => setSubscriptionStatus('idle'), 5000);
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
      <section className="relative pt-32 pb-20 overflow-hidden">
        <div className="absolute inset-0 z-0">
          <img
            src="https://readdy.ai/api/search-image?query=Modern%20business%20news%20media%20digital%20communication%20technology%20abstract%20background%20professional%20corporate%20environment%20blue%20and%20white%20tones&width=1920&height=800&seq=newshero&orientation=landscape"
            alt="Alpine Precision Molding News and Updates"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-slate-900/90 via-slate-900/80 to-slate-900/70"></div>
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <span className="inline-block px-4 py-1.5 bg-primary-500/20 text-primary-300 text-sm font-medium rounded-full mb-6">
              Latest Updates
            </span>
            <h1 className="font-display font-bold text-4xl md:text-5xl lg:text-6xl text-white mb-6">
              News &amp; Industry Insights
            </h1>
            <p className="text-xl text-slate-300 leading-relaxed">
              Stay informed about Alpine Precision Molding's latest developments, industry trends, and technological innovations in precision manufacturing.
            </p>
          </div>
        </div>
      </section>

      {/* Featured Article */}
      <section className="py-16 bg-slate-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-2xl overflow-hidden shadow-xl">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-0">
              <div className="relative h-96 lg:h-auto">
                <img
                  src={featuredArticle.image}
                  alt={featuredArticle.title}
                  className="w-full h-full object-cover object-center"
                />
                <div className="absolute top-6 left-6">
                  <span className="px-4 py-1.5 bg-primary-500 text-white text-sm font-semibold rounded-full">
                    Featured
                  </span>
                </div>
              </div>
              <div className="p-8 lg:p-12 flex flex-col justify-center">
                <div className="flex items-center gap-3 mb-4">
                  <span className="px-3 py-1 bg-primary-50 text-primary-600 text-xs font-medium rounded-full">
                    {categories.find(c => c.id === featuredArticle.category)?.name}
                  </span>
                  <span className="text-sm text-slate-500">{featuredArticle.date}</span>
                  <span className="text-sm text-slate-500">• {featuredArticle.readTime}</span>
                </div>
                <h2 className="font-display font-bold text-3xl text-slate-900 mb-4">
                  {featuredArticle.title}
                </h2>
                <p className="text-slate-600 text-lg mb-6 leading-relaxed">
                  {featuredArticle.excerpt}
                </p>
                <div className="flex items-center justify-between">
                  <div className="flex items-center">
                    <div className="w-10 h-10 bg-primary-100 rounded-full flex items-center justify-center mr-3">
                      <span className="text-primary-600 font-semibold text-sm">
                        {featuredArticle.author.split(' ').map(n => n[0]).join('')}
                      </span>
                    </div>
                    <div>
                      <div className="font-medium text-slate-900">{featuredArticle.author}</div>
                      <div className="text-sm text-slate-500">Author</div>
                    </div>
                  </div>
                  <button className="px-6 py-3 bg-primary-500 text-white font-semibold rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer">
                    Read Article <i className="ri-arrow-right-line ml-2"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Category Filter */}
      <section className="py-12 bg-white border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-wrap items-center justify-center gap-3">
            {categories.map((category) => (
              <button
                key={category.id}
                onClick={() => setSelectedCategory(category.id)}
                className={`px-6 py-3 rounded-lg font-medium transition-all whitespace-nowrap cursor-pointer ${
                  selectedCategory === category.id
                    ? 'bg-primary-500 text-white shadow-lg shadow-primary-500/30'
                    : 'bg-slate-100 text-slate-700 hover:bg-slate-200'
                }`}
              >
                <i className={`${category.icon} mr-2`}></i>
                {category.name}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Articles Grid */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredArticles.map((article) => (
              <article
                key={article.id}
                className="bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 group cursor-pointer"
              >
                <div className="relative h-56 overflow-hidden">
                  <img
                    src={article.image}
                    alt={article.title}
                    className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute top-4 left-4">
                    <span className="px-3 py-1 bg-white/90 backdrop-blur-sm text-slate-700 text-xs font-medium rounded-full">
                      {categories.find(c => c.id === article.category)?.name}
                    </span>
                  </div>
                </div>
                <div className="p-6">
                  <div className="flex items-center gap-2 text-sm text-slate-500 mb-3">
                    <span>{article.date}</span>
                    <span>•</span>
                    <span>{article.readTime}</span>
                  </div>
                  <h3 className="font-display font-semibold text-xl text-slate-900 mb-3 line-clamp-2 group-hover:text-primary-600 transition-colors">
                    {article.title}
                  </h3>
                  <p className="text-slate-600 text-sm mb-4 line-clamp-3">
                    {article.excerpt}
                  </p>
                  <div className="flex flex-wrap gap-2 mb-4">
                    {article.tags.map((tag) => (
                      <span
                        key={tag}
                        className="px-2 py-1 bg-slate-100 text-slate-600 text-xs rounded-md"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                  <div className="flex items-center justify-between pt-4 border-t border-slate-100">
                    <div className="flex items-center">
                      <div className="w-8 h-8 bg-primary-100 rounded-full flex items-center justify-center mr-2">
                        <span className="text-primary-600 font-semibold text-xs">
                          {article.author.split(' ').map(n => n[0]).join('')}
                        </span>
                      </div>
                      <span className="text-sm text-slate-700 font-medium">{article.author}</span>
                    </div>
                    <button className="text-primary-600 font-medium text-sm hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer">
                      Read More <i className="ri-arrow-right-line ml-1"></i>
                    </button>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* Newsletter Subscription */}
      <section className="py-20 bg-gradient-to-br from-primary-500 via-primary-600 to-primary-700">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="w-16 h-16 bg-white/20 rounded-2xl flex items-center justify-center mx-auto mb-6">
            <i className="ri-mail-line text-3xl text-white"></i>
          </div>
          <h2 className="font-display font-bold text-3xl md:text-4xl text-white mb-4">
            Stay Updated with Our Newsletter
          </h2>
          <p className="text-lg text-primary-100 mb-8">
            Get the latest news, industry insights, and exclusive updates delivered directly to your inbox.
          </p>
          <form 
            id="newsletter-subscription" 
            data-readdy-form 
            onSubmit={handleNewsletterSubmit}
            className="max-w-xl mx-auto"
          >
            <div className="flex flex-col sm:flex-row gap-3">
              <input
                type="email"
                name="email"
                placeholder="Enter your email address"
                required
                className="flex-1 px-6 py-4 rounded-lg text-slate-900 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-white"
              />
              <button
                type="submit"
                className="px-8 py-4 bg-slate-900 text-white font-semibold rounded-lg hover:bg-slate-800 transition-colors whitespace-nowrap cursor-pointer"
              >
                Subscribe <i className="ri-send-plane-fill ml-2"></i>
              </button>
            </div>
            {subscriptionStatus === 'success' && (
              <p className="text-sm text-white mt-4 bg-white/20 rounded-lg py-2 px-4">
                ✓ Thank you for subscribing! Check your inbox for confirmation.
              </p>
            )}
            {subscriptionStatus === 'error' && (
              <p className="text-sm text-white mt-4 bg-red-500/30 rounded-lg py-2 px-4">
                ✗ Something went wrong. Please try again.
              </p>
            )}
            {subscriptionStatus === 'idle' && (
              <p className="text-sm text-primary-100 mt-4">
                We respect your privacy. Unsubscribe at any time.
              </p>
            )}
          </form>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-slate-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="font-display font-bold text-3xl md:text-4xl text-slate-900 mb-4">
            Have a Project in Mind?
          </h2>
          <p className="text-lg text-slate-600 mb-8">
            Let's discuss how Alpine Precision Molding can bring your manufacturing vision to life.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/contact"
              className="px-8 py-4 bg-gradient-to-r from-primary-500 to-primary-600 text-white text-base font-semibold rounded-lg hover:from-primary-600 hover:to-primary-700 transition-all shadow-lg shadow-primary-500/30 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-mail-line mr-2"></i>
              Contact Us Today
            </Link>
            <Link
              to="/projects"
              className="px-8 py-4 bg-white border border-slate-200 text-slate-700 text-base font-semibold rounded-lg hover:bg-slate-50 transition-all whitespace-nowrap cursor-pointer"
            >
              <i className="ri-folder-line mr-2"></i>
              View Our Projects
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default NewsPage;
